import ExportFieldLabel from './ExportFieldLabel'
import ExportHoverTooltip from './ExportHoverTooltip'
import { REPORT_DATA_SCOPE } from './exportDataScope'
import { EXPORT_REPORT_SETTINGS_TOOLTIPS } from './exportReportSettingsTooltips'
import './ExportDataScope.css'

const REPORT_DATA_SCOPE_OPTIONS = [
  {
    value: REPORT_DATA_SCOPE.CURRENT_VIEW,
    id: 'export-report-data-current-view',
    label: 'Current view',
    tooltip: EXPORT_REPORT_SETTINGS_TOOLTIPS.reportDataCurrentView,
  },
  {
    value: REPORT_DATA_SCOPE.ALL_DATA,
    id: 'export-report-data-all-data',
    label: 'All data',
    tooltip: EXPORT_REPORT_SETTINGS_TOOLTIPS.reportDataAllData,
  },
]

function ExportReportDataOption({
  id,
  name,
  value,
  checked,
  label,
  tooltip,
  onChange,
}) {
  return (
    <ExportHoverTooltip
      as="label"
      content={tooltip}
      className={`dashboardExportFormat${checked ? ' is-active' : ''}`}
      htmlFor={id}
    >
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </ExportHoverTooltip>
  )
}

export default function ExportReportDataSection({ value, onChange }) {
  return (
    <div className="dashboardExportField dashboardExportField--segmented">
      <ExportFieldLabel tooltip={EXPORT_REPORT_SETTINGS_TOOLTIPS.reportData}>
        Report data
      </ExportFieldLabel>
      <div className="dashboardExportFormats">
        {REPORT_DATA_SCOPE_OPTIONS.map((option) => (
          <ExportReportDataOption
            key={option.value}
            id={option.id}
            name="export-report-data-scope"
            value={option.value}
            checked={value === option.value}
            label={option.label}
            tooltip={option.tooltip}
            onChange={() => onChange(option.value)}
          />
        ))}
      </div>
    </div>
  )
}
